const menuSite = function() { 
    const menuClose = document.querySelector('header nav .menu-icons .close');
    const menuOpen = document.querySelector('header nav .menu-icons .open');
    menuClose.addEventListener('click', function() {
        document.querySelector('header nav').classList.add('menu-close');
        document.querySelector('header nav').classList.remove('menu-open');
    })
    menuOpen.addEventListener('click', function() {
        document.querySelector('header nav').classList.add('menu-open');
        document.querySelector('header nav').classList.remove('menu-close');
    })
}

addFunctionOnWindowLoad(menuSite);